module.exports = __webpack_public_path__ + "img/35_5.ca4a315a.png";